import React, { useState, useEffect, useRef } from "react";
const FileUpload = (props) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const [dropZoneClick, setDropZoneClick] = useState(0);
  const [myFile, setMyFile] = useState([]);
  const [myFileUpdate, setMyFileUpdate] = useState([]);
  const [myFileUrl, setMyFileUrl] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const dropZoneRef = useRef(null);
  /* ==============================
     LOAD EDIT DATA (single/multiple)
  ============================== */
  useEffect(() => {
    if (!props.editposts) return;

    let newFiles, newUrls;
    console.log("###333", props.editposts);
    if (Array.isArray(props.editposts)) {
      const paths = props.editposts.map((file) => "upload/" + file);
      newFiles = props.editposts;
      newUrls = paths.map((path) => BACKEND_URL + path);
    } else {
      const path = "upload/" + props.editposts;
      newFiles = [props.editposts];
      newUrls = [BACKEND_URL + path];
    }

    // ✅ prevent unnecessary state updates
    if (JSON.stringify(newFiles) !== JSON.stringify(myFile)) {
      setMyFile(newFiles);
      setMyFileUpdate(newUrls);
      setMyFileUrl(newUrls);
    }
  }, [props.editposts, BACKEND_URL]);

  /* ==============================
     HANDLE DROP ZONE LOGIC
  ============================== */
  useEffect(() => {
    dropZoneUpload();
  }, [dropZoneClick, myFileUrl]);
  //}, []);

  /* ==============================
     RETURN DATA TO PARENT
  ============================== */
  useEffect(() => {
    props.setReturnUpload({
      myFile,
      myFileUpdate,
      myFileUrl,
    });
    //}, [myFile, myFileUpdate, myFileUrl, props]);
  }, [myFile, myFileUpdate, myFileUrl]);

  /* ==============================
     JSX
  ============================== */
  return (
    <div className="col-md-12 mb-3">
      <div className="card">
        <div className="card-header text-white bg-success p-3">
          <i className="fa fa-image"></i> {props.titileHead}
        </div>

        <div className="card-body">
          <div className="row m-1">
            <div className="col-lg-12">
              <div className="form-group row">
                <div className="drop-zone" ref={dropZoneRef}>
                  <span className="drop-zone__prompt">
                    Click here to upload File / Image
                  </span>

                  <input
                    accept="image/png, image/jpeg, image/jpg, application/pdf"
                    type="file"
                    name="item01"
                    multiple={props.maxFiles > 1}
                    className="drop-zone__input"
                    onChange={(event) => {
                      let files = Array.from(event.target.files);

                      if (props.maxFiles) {
                        files = files.slice(0, props.maxFiles);
                      }

                      setMyFile(files); // ONLY real File objects
                      setMyFileUpdate(files); // ONLY for new uploads

                      const urls = files.map((file) =>
                        URL.createObjectURL(file),
                      );

                      setMyFileUrl(urls);
                      setDropZoneClick((prev) => prev + 1);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  /* ==============================
     DROP ZONE FUNCTION
  ============================== */
  function dropZoneUpload() {
    const inputElement =
      dropZoneRef.current?.querySelector(".drop-zone__input");

    if (!inputElement) return;

    const dropZoneElement = inputElement.closest(".drop-zone");

    // ✅ Always update preview
    if (myFileUrl.length > 0) {
      updateThumbnailFromUrl(dropZoneElement, myFileUrl);
    }

    // ✅ Prevent duplicate listeners
    if (dropZoneElement.dataset.listenerAdded) return;
    dropZoneElement.dataset.listenerAdded = "true";

    dropZoneElement.addEventListener("click", () => {
      inputElement.click();
    });

    inputElement.addEventListener("change", () => {
      if (inputElement.files.length) {
        updateThumbnail(dropZoneElement, inputElement.files);
      }
    });

    dropZoneElement.addEventListener("drop", (e) => {
      e.preventDefault();

      if (e.dataTransfer.files.length) {
        inputElement.files = e.dataTransfer.files;
        updateThumbnail(dropZoneElement, e.dataTransfer.files);
      }

      dropZoneElement.classList.remove("drop-zone--over");
    });

    function updateThumbnailFromUrl(dropZoneElement, urls) {
      const prompt = dropZoneElement.querySelector(".drop-zone__prompt");
      if (prompt) prompt.remove();

      dropZoneElement
        .querySelectorAll(".drop-zone__thumb")
        .forEach((el) => el.remove());

      urls.forEach((url, index) => {
        const thumb = document.createElement("div");
        thumb.classList.add("drop-zone__thumb");

        thumb.dataset.label =
          typeof myFile[index] === "string"
            ? myFile[index]
            : myFile[index]?.name;

        thumb.style.backgroundImage = `url(${url})`;

        dropZoneElement.appendChild(thumb);
      });
    }

    function updateThumbnail(dropZoneElement, files) {
      const prompt = dropZoneElement.querySelector(".drop-zone__prompt");
      if (prompt) prompt.remove();

      dropZoneElement
        .querySelectorAll(".drop-zone__thumb")
        .forEach((el) => el.remove());

      Array.from(files).forEach((file) => {
        const thumb = document.createElement("div");
        thumb.classList.add("drop-zone__thumb");

        thumb.dataset.label = file.name;

        if (file.type.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = () => {
            thumb.style.backgroundImage = `url(${reader.result})`;
          };

          reader.readAsDataURL(file);
        }

        dropZoneElement.appendChild(thumb);
      });
    }
  }
};

export default FileUpload;
